import config from "../config";
import type { APIConfigType } from "./types";

const { baseApiURL } = config;

const hotelBaseUrl = `${baseApiURL}hotel/v1/`;
const hotelBaseUrlV1o1 = `${baseApiURL}hotel/v1.1/`;
const clientHotelBaseUrl = "/api/hotel/";

export const API_CONFIG = {
  cities: {
    client: `${clientHotelBaseUrl}cities`,
    back: `${hotelBaseUrl}cities`,
  },
  cityByIata: (iata: string) => `${hotelBaseUrl}cities/${iata}`,
  availability: `${hotelBaseUrlV1o1}availability`,
  accommodations: `${hotelBaseUrlV1o1}accommodations`,
  cityAccommodations: `${hotelBaseUrlV1o1}city_accommodations/accommodations`,
  accommodationPrices: `${hotelBaseUrlV1o1}city_accommodations/prices`,
  detail: (hotel: string) => `${hotelBaseUrlV1o1}accommodations/${hotel}`,
  detailSeo: (hotel: string) =>
    `${hotelBaseUrlV1o1}accommodations/${hotel}/seo`,
  exclusiveAmazingAccommodations: `${hotelBaseUrlV1o1}exclusive-amazing-accommodations`,
  detailBySlug: (slug: string) => `${hotelBaseUrlV1o1}${slug}/detail`,
  detailByKey: (key: string) => `${hotelBaseUrlV1o1}${key}/details`,
  calculatePrice: {
    client: `${clientHotelBaseUrl}calculatePrice`,
    back: `${hotelBaseUrl}price/calculate`,
  },
  comment: {
    client: `${clientHotelBaseUrl}comment`,
    back: `${hotelBaseUrl}comment`,
  },
  commentImageUploader: {
    client: `${clientHotelBaseUrl}comment/uploadImages`,
    back: `${hotelBaseUrl}comment/uploadImages`,
  },

  check: {
    client: `${clientHotelBaseUrl}check`,
    back: `${hotelBaseUrl}check`,
  },
  book: {
    client: `${clientHotelBaseUrl}book`,
    back: `${hotelBaseUrl}order/book`,
  },
  storePassengers: {
    client: `${clientHotelBaseUrl}passengers`,
    back: `${hotelBaseUrlV1o1}passenger/store`,
  },
  getPassengers: (passengerKey: string) =>
    `${hotelBaseUrlV1o1}passenger/${passengerKey}`,
  getCommentOptions: `${hotelBaseUrl}comment/getOptions`,
  hasComment: (uniqueId: string) =>
    `${hotelBaseUrl}comment/hasCommented?unique_id=${uniqueId}`,
};

export const HOTEL_API_CONFIG: APIConfigType<typeof API_CONFIG> = API_CONFIG;
